import { FormHorizontal } from '~/components/form/layout';
import ZodFieldSelect from '~/components/zod/ZodFieldSelect';
import ZodFieldTextarea from '~/components/zod/ZodFieldTextarea';
import { format_money } from '~/components/Money';
import TwtNucleusJob from '~/tenants/twt/performable/nucleus/TwtNucleusJob';

export default function TwtNucleusHotspotsForm() {
  return (
    <>
      <FormHorizontal label="Hot Spots">
        <ZodFieldSelect
          options={[
            { label: `20 Hot Spots: ${format_money(TwtNucleusJob.hotspots(20))}`, value: '20' },
            { label: `40 Hot Spots: ${format_money(TwtNucleusJob.hotspots(40))}`, value: '40' },
            { label: `100 Hot Spots: ${format_money(TwtNucleusJob.hotspots(100))}`, value: '100' },
            { label: `500 Hot Spots: ${format_money(TwtNucleusJob.hotspots(500))}`, value: '500' },
          ]}
          name="hotspots"
        />
      </FormHorizontal>
      <FormHorizontal label="Hot Spot Information">
        <ZodFieldTextarea name="instructions" />
      </FormHorizontal>
    </>
  );
}
